module.exports = __webpack_public_path__ + "static/media/icon-xfmer.83e1c5a0.svg";